var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2NewHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M534.7,183.2c4.5-4.6,22-19.4,14.6-24c-108.5-17.4-220.5-20.9-330.5-7.8c-14.5,1.7-29,3.7-43.4,5.9 c-8.2,1.4-16.3,3-24.4,4.8c-1.8,4.5,5.4,12.1,8,15c4.9,5.4,9.9,11,15.6,15.9c6.3,5.4,14,10,21.5,10 c100.1-21.5,206.5-20.5,308.7-3.8C518.1,198.6,526.6,191.4,534.7,183.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M206.5,152.9c-10.4,1.3-20.8,2.8-31.1,4.4c-8.2,1.4-16.3,3-24.4,4.8c-1.8,4.5,5.4,12.1,8,15 c4.9,5.4,9.9,11,15.6,15.9c6.3,5.4,14,10,21.5,10c36.3-7.8,73.5-12.6,111-14.8C270.3,182.9,232.8,174.4,206.5,152.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M213.5,59.7c-11,27.3-18.9,65.1-19.9,94.9c8.4-1.2,16.8-2.3,25.2-3.2c95.9-11.5,193.3-10.2,288.5,1.8 c-3.1-35-9.7-69.4-22.3-101.8C413.3,33.5,295.7,27.2,213.5,59.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M213.5,59.7c-8.9,22-15.7,50.8-18.6,76.8c13-2.5,26.3-4.7,39.8-6.5c0.1-26.9,4.9-58.1,11.8-80.9 C235.1,52.1,224,55.6,213.5,59.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M194.9,136.5c-0.7,6.2-1.1,12.3-1.3,18.1c8.4-1.2,16.8-2.3,25.2-3.2c95.9-11.5,193.3-10.2,288.5,1.8 c-0.5-5.5-1.1-11-1.8-16.5C411.2,117.3,293.1,117.6,194.9,136.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M451.5,128c-9.2-1.1-18.5-2-27.9-2.8l1,20.4c9.4,0.6,18.8,1.2,28.2,2L451.5,128z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2NewHair2);
export default __webpack_public_path__ + "static/media/m-hat2_new-hair2.f2940a57e765c78bbb2b71e981c4b357.svg";
export { ForwardRef as ReactComponent };